import axios from "axios";

export default class Auth {
  constructor() {
    this.base_url = process.env.REACT_APP_URL_AUTH;
    this.name = "/public";
    this.url = this.base_url + this.name;
  }

  login = async (payload) => {
    return await axios.post(`${this.url}/login`, payload);
  };

  refresh = async (token) => {
    return await axios.get(`${this.url}/refresh`, {
      headers: { authorization: `Bearer ${token}` },
      // Marca esta llamada para que el interceptor no intente un nuevo
      // refresh si este endpoint mismo devuelve 401 (evita ciclo infinito).
      _isRefreshCall: true,
    });
  };
}
